export default {
  metaDescription: 'Baca artikel lengkap dari PT Tokki Engineering and Fabrication (TEF), mencakup berita perusahaan, pencapaian proyek, dan wawasan industri.',
  pageTitle: 'Detail Berita & Blog',
  backToList: 'Kembali ke Berita & Blog',
  sidebar: {
    title: 'Berita & Blog Lainnya',
  },
};
